module.exports = __webpack_public_path__ + "assets/img/link_img_b.2f153e15.png";